import values from 'lodash/values';
import { AttachmentEntity } from 'src/logic/features/attachments/attachment.service';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';

export const useAttachments = (entity: AttachmentEntity) => {
    const attachments = useRootSelector(state => {
        switch (entity.type) {
            case 'jobs':
                return state.jobs.items[entity.id]?.attachments || [];
            case 'eventrequests':
                return state.eventUnions.items[entity.id]?.eventRequest?.attachments || [];
            case 'events':
                return state.eventUnions.items[entity.id]?.event?.attachments || [];
        }
    });

    const deletedIds = useRootSelector(state =>
        values(state.attachments.deleteState)
            .filter(i => !!i && i.deleted)
            .map(i => i!.id)
    );

    return attachments.filter(i => !deletedIds.includes(i.storedFileId));
};
